/**
 * Created by cristianofaria on 23/10/2017.
 */
/************************************************************
 MCDT Namespace
 ************************************************************/

window.mcdtNS = {
    _action:null,
    _callback:null,
    _row:null,

    // Execute Action
    executeAction:function (action, row, callback) {

        debug.log('mcdtNS, action:', action);

        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;
        this._wf_action_params = action.wf_action_params != null ? $.parseJSON(action.wf_action_params) : null ;

        if (actionId == 3 || actionId == 15 ) {
            debug.log('appointmentNS.executeAction ; MCDT 1', this._action.to_state_id );
            //mcdtNS.openCancelAppointmentModal(this._action, this._row, this._callback);
            mcdtNS.openReason(mcdtNS.cancelAppointment);
            //mcdtNS.openGenericReasonModal();
        }// Undo Patient Arrival
        else if (actionId == 74) {
            debug.log('mcdtNS.openReason ;  MCDT 1.2');
            //mcdtNS.openReason(mcdtNS.undoPatientArrivalReasonModalHandler);
            mcdtNS.openPatientAbsence(mcdtNS.setPatientAbsenceModalHandler)
        }
        else if (actionId == 155) {
            mcdtNS.openGenericReasonModal();
        }
        else if (actionId == 2) {
            debug.log('mcdtNS.openReason ;  MCDT 1.3');
            mcdtNS.openScheduler();
        }
        else if (actionId == 17) {
            debug.log('mcdtNS.openReason ;  MCDT 2');
            mcdtNS.openReason(mcdtNS.undoPatientArrivalReasonModalHandler);
        }
        else if ( actionId == globalConstants.ACTION_PRINT_EXAM_DELIVERABLE_TICKET ){ // 125 Talão de Entrega
            debug.log('mcdtNS.printExamDelivarableTicket ; MCDT 3');
            mcdtNS.printExamDelivarableTicket(this._action, this._row, this._callback);
        }
        else if ( actionId == globalConstants.ACTION_PRINT_PROCESS_DELIVERABLE_TICKET ){ // 157 Talão de Entrega Processo
            debug.log('mcdtNS.printExamDelivarableTicket ; MCDT 3');
            mcdtNS.printProcessDelivarableTicket(this._action, this._row, this._callback);
        }
        else if ( actionId == globalConstants.ACTION_ASSOCIATED_RESULT ){  // 126
            debug.log('mcdtNS.AssociatedResults ; MCDT 4');
            mcdtNS.AssociatedResults(this._action, this._row, this._callback, this._wf_action_params);
        }
        // else if ( actionId == globalConstants.ACTION_DELIVERY_RESULT ) { // 127 -> Entrega (modal)
        //     debug.log('mcdtNS.openDeliverModal ; MCDT 5');
        //     mcdtNS.openDeliverModal();
        // }
        else if ( actionId == 5 && (parseInt(this._row.appointment_type_id) == globalConstants.APPOINTMENT_TYPE_EXAM && parseInt(this._row.treatment_type_id) == globalConstants.TREATMENT_TYPE_MCDT) ) {
            debug.log('mcdtNS.checkPreviewsFinalized ; MCDT 6');
            mcdtNS.checkPreviewsFinalized();
        }
        //Undo Finalize Episode
        else if ( actionId == 100  &&  (parseInt(this._row.appointment_type_id) == globalConstants.APPOINTMENT_TYPE_EXAM && parseInt(this._row.treatment_type_id) == globalConstants.TREATMENT_TYPE_MCDT)) {
            debug.log('mcdtNS.checkCanUndoFinalizeEpisode ; MCDT 7');
            mcdtNS.checkCanUndoFinalizeEpisode();
        }
        //Undo Start Episode
        else if (actionId == 99) {
            debug.log('mcdtNS.openReason ; MCDT 8');
            mcdtNS.openReason(mcdtNS.undoStartEpisode)
        }
        else if  ( actionId == 109 || actionId == 110 ) {
            debug.log('episode.openReason ; 9');
            mcdtNS.openReason(mcdtNS.administrativeActions)
        }else if  ( actionId == 136 ) {
            debug.log('episode.openReason ; 10');
            mcdtNS.undoMcdtTrnasference();
        }
        else if  ( actionId == 98 ) {
            debug.log('episode.openSendToLabModal ; 11', this._row.financial_institution_id );
            mcdtNS.openSendToLabModal();
        }
        else if  ( actionId == 130 ) {
            debug.log('episode.openTransferenceModal ; 12' );
            mcdtNS.openDeliverModal();
        }
        else if  ( actionId == 131 ) {
            debug.log('episode.openTransferenceModal ; 13' );
            mcdtNS.openTransferenceModal();
        }
        else if  ( actionId == 133 ) { // Cancel Sending to Lab
            debug.log('episode.openTransferenceModal ; 14' );
            mcdtNS.undoMCDTSendToLab();
        }
        else if  ( actionId == 135 ) { // Cancel Delivery
            debug.log('episode.openTransferenceModal ; 15' );
            mcdtNS.cancelDelivery();
        }

        else if (actionId == 124) {

            mcdtNS.editCredential(action, row, callback);
        }
        // Other actions}
        else {
            debug.log('executeGenericAction MCDT');
            mcdtNS.executeGenericAction();
        }

    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.doExecuteGenericAction(mcdtNS._action, mcdtNS._callback, mcdtNS._row);
    },

    undoMcdtTrnasference: function () {

        Hades.showLoading();
        //$.fancybox.close(true);

        var params = {
            task_id:mcdtNS._action.task_id,
            wf_id:mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id:mcdtNS._action.wf_action_id,
            actionId: mcdtNS._action.wf_action_id};

        $.post('/mcdt/undo_mcdt_transference', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });

    },

    undoMCDTSendToLab: function () {
        Hades.showLoading();
        //$.fancybox.close(true);

        var params = {
            task_id:mcdtNS._action.task_id,
            wf_id:mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id:mcdtNS._action.wf_action_id,
            actionId: mcdtNS._action.wf_action_id};

        $.post('/mcdt/undo_mcdt_send_to_lab', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });

    },

    cancelDelivery: function(){

        var params = {
            task_id:mcdtNS._action.task_id,
            wf_id:mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id:mcdtNS._action.wf_action_id,
            actionId: mcdtNS._action.wf_action_id};

        $.post('/mcdt/cancel_delivery_upd_delivery_status', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });


    },

    openGenericReasonModal: function (callback){
        //workflow.openGenericReasonModal(specific_callback);
        var params = {
            task_id: mcdtNS._action.task_id,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_to_state_id: mcdtNS._action.to_state_id,
            wf_action_id: mcdtNS._action.wf_action_id
        };


        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                if (callback) {
                    $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);
                }else{
                    $('#generic-reason-modal-ct').bind('genericReasonConfirmed', mcdtNS.executeGenericActionWithReason);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                workflow._callback(false, workflow._action, workflow._row);
            });
    },

    editCredential:function (action, row, callback) {
        CredentialNS.MODES.EDIT_MODAL = null;

        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;


        //Get Credential ID


        CredentialNS.editCredential(null, mcdtNS.restoreCredentialNSState /*callback*/, action.params);

        //CredentialNS.MODES.EDIT_MODAL = 'EDIT_MODAL';
    },
    restoreCredentialNSState: function(data){
        CredentialNS.MODES.EDIT_MODAL = 'EDIT_MODAL';

        if (mcdtNS._callback){
            mcdtNS._callback();
        }else{
            Hades.hideLoading();
        }
    },
    markPatientArrival: function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        var params = {
            wf_id: wfId,
            task_id: action.task_id
        };

        $.getJSON('/credential/check_mandatory_credential', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                debug.log('mcdt/check_mandatory_credential',data);

                if (data.mandatory_credential == true){
                    mcdtNS.editCredential(mcdtNS._action, mcdtNS._row, mcdtNS._callback);
                }else{
                    if (mcdtNS._callback){
                        mcdtNS._callback();
                    }else{
                        Hades.hideLoading();
                    }
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },
    printExamDelivarableTicket: function(action, row, callback){
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        debug.log('mcdtNS printExamDelivarableTicket', action);

        var url = "/mcdt/exam_deliverable_ticket?episode_id="+row.task_id+"&task_id="+action.task_id;

        Hades.showDocument(url);

    },
    printProcessDelivarableTicket: function(action, row, callback){
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        debug.log('mcdtNS printExamDelivarableTicket', action);

        var url = "/mcdt/process_deliverable_ticket?task_id="+action.task_id;

        Hades.showDocument(url);

    },
    AssociatedResults: function(action, row, callback, wf_action_params){

        debug.log("this 2", this._wf_action_params);
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        debug.log("wf_action_params", wf_action_params[0].shortcut_id);
        debug.log("action", action);

        Hades.loadShortcut(wf_action_params[0].shortcut_id, {id: action.task_id, type: 'episode', wf_id: action.wf_id })   ;
        Hades.hideLoading();

    },

    openReason:function (callback) {

        var params = {
            task_id:mcdtNS._action.task_id,
            wf_id:mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id:mcdtNS._action.wf_action_id,
            actionId: mcdtNS._action.wf_action_id
        };


        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },

    undoPatientArrivalReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:mcdtNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:mcdtNS._row.wf_id,
            wf_status_id:mcdtNS._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/episode/undo_patient_arrival', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },
    openDeliverModal: function () {
        var params = {
            task_id: mcdtNS._action.task_id,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id: mcdtNS._action.wf_action_id};

        $.get('/mcdt/deliver_results_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, 'width':600,
                    'autoSize' : false});

                $('#delivery-contacts-container_modal').bind('McdtDeliveryConfirmed', mcdtNS.executeGenericAction );

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },

    openSendToLabModal: function () {
        var params = {
            task_id: mcdtNS._action.task_id,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id: mcdtNS._action.wf_action_id,
            financial_institution_id: mcdtNS._row.financial_institution_id,
            patient_id:  mcdtNS._row.patient_id,
            episode_id: mcdtNS._row.episode_id
        };

        $.get('/mcdt/send_to_lab_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#send-to-lab-ct').bind('SendToLabModalConfirmed', mcdtNS.executeGenericAction );

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });

    },

    openTransferenceModal: function () {
        var params = {
            task_id: mcdtNS._action.task_id,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id: mcdtNS._action.wf_action_id,
            patient_id:  mcdtNS._row.patient_id,
            episode_id: mcdtNS._row.episode_id};


        $.get('/mcdt/mcdt_transference_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox( {content:data, autoScale:true, autoDimensions:true} );

                $('#mcdt-transference-container').bind('McdtTransferenceConfirmed', mcdtNS.executeGenericAction);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });

    },

    checkPreviewsFinalized: function (){
        var params = {
            wf_id: mcdtNS._action.wf_id,
            task_id: mcdtNS._action.task_id
        };

        $.getJSON('/workflow/check_previous_finalized', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (!data.finalized_count || data.finalized_count == 0) {

                    var params = {
                        task_id: mcdtNS._action.task_id,
                        wf_id: mcdtNS._action.wf_id,
                        wf_status_id: mcdtNS._action.from_state_id,
                        wf_action_id: mcdtNS._action.wf_action_id,
                        reason_id: null,
                        other_reason: null,
                        date: null,
                        hour: null
                    };

                    processNS.execute(mcdtNS._action, mcdtNS._row, mcdtNS.executeGenericAction, params);
                }
                else {
                    mcdtNS.openReason(mcdtNS.finalizedEpisodeReasonModalHandler);
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError();
                Hades.hideLoading();
            });

    },

    finalizedEpisodeReasonModalHandler: function (event, data) {

        var params = {
            task_id: mcdtNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: mcdtNS._row.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_action_id: data.actionId
        };

        mcdtNS._action.finalized_modal = params;

        processNS.execute(mcdtNS._action, mcdtNS._row, mcdtNS.executeGenericAction, params);
    },
    checkCanUndoFinalizeEpisode: function(){
        var params = mcdtNS._action;

        processNS.execute(mcdtNS._action, mcdtNS._row, mcdtNS.undoFinalizeEpisodeProcess, params);

    },
    undoFinalizeEpisodeProcess: function(){
        mcdtNS.openReason(mcdtNS.undoFinalizeEpisodeProcessHandler);
    },
    undoFinalizeEpisodeProcessHandler: function (evt, data) {
        var params = {
            task_id: mcdtNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: mcdtNS._row.wf_id,
            wf_status_id: mcdtNS._row.wf_status_id
        };

        mcdtNS._action.modal_params = params;

        mcdtNS.undoFinalizeEpisode();
    },
    undoFinalizeEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {};
        if (!mcdtNS._action.modal_params){
            var params = {
                task_id:mcdtNS._row.task_id,
                reason_id:data.reasonId,
                other_reason:data.otherReason,
                date:data.date,
                hour:data.hour,
                wf_id:mcdtNS._row.wf_id,
                wf_status_id:data.wf_from_state_id,
                wf_action_id: data.wf_action_id};
        }else{
            params = mcdtNS._action.modal_params;
        }

        mcdtNS._action.modal_params = params;

        if ((parseInt(mcdtNS._row.appointment_type_id) == globalConstants.APPOINTMENT_TYPE_EXAM && parseInt(mcdtNS._row.treatment_type_id) == globalConstants.TREATMENT_TYPE_MCDT)){
            processNS.reopenProccess(mcdtNS.undoEpisode, params);
        }else{
            mcdtNS.undoEpisode();
        }


    },
    undoEpisode: function(){
        var params = mcdtNS._action.modal_params;

        debug.log('undoEpisode', params);

        $.post('/episode/undo_finalize_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },

    undoStartEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {
            task_id:mcdtNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:mcdtNS._row.wf_id,
            wf_status_id:data.wf_from_state_id,
            wf_action_id:data.wf_action_id};

        $.post('/episode/undo_start_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },

    administrativeActions: function(event, data) {
        $.fancybox.close(true);
        var params = {
            task_id:mcdtNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:mcdtNS._row.wf_id,
            wf_status_id:data.wf_status_id,
            wf_action_id:data.wf_action_id};

        $.post('/episode/administrative_actions', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },

    cancelAppointment: function (event, data) {
        $.fancybox.close(true);

        debug.log('cancelAppointment',data)
        var params = {
            task_id:mcdtNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: data.wf_status_id,
            wf_action_id: mcdtNS._action.wf_action_id
        };

        $.post('/episode/cancel_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                debug.log('Cancellll', data.success);
                if (data.success != true) {
                    Hades.showError(data.error, xhr.responseText, xhr, status, data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },

    setPatientAbsenceModalHandler: function (event, data) {
        Hades.hideLoading();
        $.fancybox.close();
        debug.log('MCDT NS data -', data);
        mcdtNS._action.to_state_id = data.state_id;
        mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
    },

    openPatientAbsence: function (callback) {
        var params = {
            task_id: mcdtNS._action.task_id,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_action_id: mcdtNS._action.wf_action_id
        };
        Hades.showLoading();
        $.get('/appointments/patient_absence_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);


                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#patient-absence-modal-ct').bind('patientAbsenceConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, mcdtNS._action, mcdtNS._row);
            });
    },

    openScheduler:function(){

        var params = {
            task_id: mcdtNS._action.task_id,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_from_state_id: mcdtNS._action.from_state_id,
            wf_action_id: mcdtNS._action.wf_action_id};

        params.width = $(window).width();
        params.can_change_appointment_type = "0";
        params.can_change_specialty = "0";
        params.can_change_professional = "0";
        params.can_change_financial_institution = "0";
        params.show_week_button = false;

        debug.log("openScheduler", params);

        $.get('/calendar/calendar_pick_date', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data});

                $('#calendar-pick-date-ct').bind('dateSelected', mcdtNS.onSchedulerCloseHandler);
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    onSchedulerCloseHandler:function(event, data) {
        $.fancybox.close(true);

        debug.log(" mcdtNS._action", mcdtNS._action);

        var params = {}
        params.professional_id = data.resource_id;
        params.professional_name = data.resource_desc;
        params.prev_date = data.prev_date;
        params.prev_hour = data.prev_hour;
        params.date = data.date;
        params.hour = data.hour;
        params.prev_professional_name = data.prev_professional_name;
        params.specialty_id = data.specialty_id;
        params.task_id = mcdtNS._action.task_id;
        params.wf_id = mcdtNS._action.wf_id;
        params.wf_status_id = mcdtNS._action.params.wf_status_id;
        params.wf_action_id = mcdtNS._action.wf_action_id;
        params.appointment_duration = data.appointment_duration;

        $.get('/workflow/confirm_reschedule', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', mcdtNS.rescheduleSession);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    rescheduleSession: function(evt, data){
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {};
        params.appointment_id = data.appointment_id;
        params.professional = data.professional_id;
        params.specialty = data.specialty_id;
        params.app_date = data.date;
        params.app_hour = data.hour;
        params.reason_id = data.reasonId;
        params.reason_desc = data.otherReason;
        params.appointment_duration = data.appointment_duration;
        params.wf_id = mcdtNS._action.wf_id;
        params.task_id = mcdtNS._action.task_id;

        $.post('/appointments/reschedule_appointment', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success == false) {
                    bootbox.alert(data.error);
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    executeGenericActionWithReason:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id: mcdtNS._action.task_id,
            wf_id: mcdtNS._action.wf_id,
            wf_status_id: mcdtNS._action.from_state_id,
            wf_action_id: mcdtNS._action.wf_action_id,

            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour
        };


        $.getJSON('/workflow/execute_generic_action_with_reason', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    mcdtNS._callback(false, mcdtNS._action, mcdtNS._row);
                } else {
                    mcdtNS._callback(true, mcdtNS._action, mcdtNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                workflow._callback(false, mcdtNS._action, mcdtNS._row);
            });
    }


};